import { render, staticRenderFns } from "./QuotationPromotion.vue?vue&type=template&id=53bfddb0"
import script from "./QuotationPromotion.vue?vue&type=script&lang=js"
export * from "./QuotationPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports